import { CompDataTableCore } from '../core/data-table/comp'

export const CompDataTable = CompDataTableCore
